import "core-js/modules/es.array.push.js";
import { createApp } from "vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import App from "./App.vue";
import SvgIcon from "@/components/SvgIcon.vue";
import router from "./router";
import store from "./store";
import "./main.css";
import "./styles/style.scss";
import "./styles/ai-style.scss";
import "./styles/fa-regular.css";
import { whoami } from "@/services/backendApi";
import { autoAnimatePlugin } from "@formkit/auto-animate/vue";
const app = createApp(App);
import { Close, CloseBold, Search, Plus, ArrowDownBold, Check } from "@element-plus/icons-vue";
for (const [key, component] of Object.entries({
  Close,
  CloseBold,
  Search,
  Plus,
  ArrowDownBold,
  Check
})) {
  app.component(key, component);
}
router.beforeEach((to, from, next) => {
  const accessToken = localStorage.getItem("access_token");
  if (to.meta.requiresAuth && !accessToken) {
    next({
      name: "login"
    });
  } else {
    next();
  }
});
whoami().then(async res => {
  if (res.isError) {
    console.log("whoami error", res.error);
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    router.push({
      name: "login"
    });
  } else {
    store.commit("setUser", res.responseData.payload);
  }
  app.use(store).use(router).use(ElementPlus).use(autoAnimatePlugin).component("SvgIcon", SvgIcon).mount("#app");
});